import dayjs from 'dayjs'

export const GENDER: { [key: string]: string } = {1: '男性', 2: '女性', 3: 'その他・回答しない'}

export namespace ADDRESS {
  export const PREFECTURES: { [key: string]: string } = {
    '01': '北海道', '02': '青森県', '03': '岩手県', '04': '宮城県', '05': '秋田県',
    '06': '山形県', '07': '福島県', '08': '茨城県', '09': '栃木県', '10': '群馬県',
    '11': '埼玉県', '12': '千葉県', '13': '東京都', '14': '神奈川県', '15': '新潟県',
    '16': '富山県', '17': '石川県', '18': '福井県', '19': '山梨県', '20': '長野県',
    '21': '岐阜県', '22': '静岡県', '23': '愛知県', '24': '三重県', '25': '滋賀県',
    '26': '京都府', '27': '大阪府', '28': '兵庫県', '29': '奈良県', '30': '和歌山県',
    '31': '鳥取県', '32': '島根県', '33': '岡山県', '34': '広島県', '35': '山口県',
    '36': '徳島県', '37': '香川県', '38': '愛媛県', '39': '高知県', '40': '福岡県',
    '41': '佐賀県', '42': '長崎県', '43': '熊本県', '44': '大分県', '45': '宮崎県',
    '46': '鹿児島県', '47': '沖縄県',
  }
}

export namespace CALENDAR {
  export const YEARS: string[] = Array.from(
    Array(110 + 1),
    (_, i) => {
      return (dayjs().year() - i).toString()
    })

  export const YEARS_FOR_CREDIT_CARD: string[] = Array.from(
    Array(14 + 1),
    (_, i) => {
      return (dayjs().year() + i).toString()
    })

  export const DAYS: string[] = Array.from(
    Array(31),
    (_, i) => (i + 1).toString().padStart(2, '0'),
  )

  export const MONTHS: string[] = Array.from(
    Array(12),
    (_, i) => (i + 1).toString().padStart(2, '0'),
  )
}

export namespace PAYMENT {
  export const TERMS: {
    [key: string]:
      { displayLabel: string, order: number }
  } = {
    'monthly': {displayLabel: '月契約', order: 1},
    'yearly': {displayLabel: '年契約', order: 2},
    'permanent': {displayLabel: '', order: 99},
  }

  export const METHODS: { [key: string]: string } = {
    'convenience_store': 'コンビニ',
    'credit_card': 'クレジットカード',
    'mobile_carrier': 'キャリア',
  }

  export const METHODS_FOR_RADIO_LABEL: { [key: string]: string } = {
    'convenience_store': 'コンビニ決済',
    'credit_card': 'クレジットカード決済',
    'mobile_carrier': 'キャリア決済',
  }

  export const SUBSCRIPTION_LABEL: { [key: string]: string } = {
    'convenience_store': '(更新する場合は手続きが必要です)',
    'credit_card': '(自動課金継続)',
    'mobile_carrier': '(自動課金継続)',
  }
}
